import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Header from '../layout/Header';
import './LegalPages.css';

const TermsOfService: React.FC = () => {
  return (
    <div className="legal-page-container">
      <Header user={null} />
      <Container className="legal-content-container">
        <div className="legal-header">
          <h1>利用規約</h1>
        </div>

        <Row>
          <Col lg={2} className="legal-ttl">TERMS OF SERVICE</Col>
          <Col lg={10}>
            <div>
              <section className="legal-section">
                <p>フォロリク利用規約（以下「本規約」といいます。）には、株式会社エグゼクティブサーチファーム（以下「当社」といいます。）の提供する本サービス（第2条に定義）のご利用にあたり、ユーザーの皆様に遵守していただかなければならない事項及び当社とユーザーの皆様との間の権利義務関係が定められております。本サービスをご利用になる方は、本規約に同意する前に、必ず全文お読み下さいますようお願い致します。</p>
              </section>

              <section className="legal-section">
                <h2>第1条 適用</h2>
                <p>個人情報を取り扱う上で、個人情報保護法をはじめとする法令や、関連ガイドライン等の国が定める指針、条例、その他の規範を確認し、遵守します。</p>
                <ol>
                  <li>本規約は、本サービスの利用に関する当社と登録ユーザー（第2条に定義）との間の権利義務関係を定めることを目的とし、登録ユーザーと当社の間の本サービスの利用に関わる一切の関係について、本規約に定める登録ユーザーの区分に応じてそれぞれ適用されます。</li>
                  <li>当社が当社ウェブサイト（第2条に定義）上で随時掲載する本サービスに関するルール、諸規定等は本規約の一部を構成するものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第2条 定義</h2>
                <p>本規約において使用する以下の用語は各々以下に定める意味を有するものとします。</p>
                <ol>
                  <li>「回答者」とは、登録ユーザーのうち、候補者等のリファレンスチェックに関する質問に回答する又は推薦を作成する個人を意味します。</li>
                  <li>「外部SNSサービス」とは、Facebook、その他の他の事業者が提供している当社所定のソーシャル・ネットワーキング・サービスで、登録ユーザーの認証、友人関係の開示、当該外部ソーシャル・ネットワーク内へのコンテンツの公開などの機能を持ち、本サービスの実施に利用されるサービスを意味します。</li>
                  <li>「外部SNS事業者」とは、外部SNSサービスのサービス提供者を意味します。</li>
                  <li>「外部SNS利用規約」とは、登録ユーザーと外部SNS事業者との権利関係を定める規約を意味します。</li>
                  <li>「求人企業」とは、登録ユーザーのうち、本サービスを通じて候補者等の採用を検討する目的で候補者等のリファレンスチェック又はバックグラウンドチェックを行う法人を意味します。</li>
                  <li>「候補者等」とは、登録ユーザーのうち、本サービスを通じて求人企業によってリファレンスチェック若しくはバックグラウンドチェックがなされる求職者又は推薦等の対象となった個人の総称を意味します。</li>
                  <li>「推薦等」とは、回答者が本サービスを通じて行った候補者等のリファレンスチェックに関する回答内容、又は求人企業を介さず回答者が自発的に候補者等について回答した回答内容の総称を意味します。</li>
                  <li>「スコアリングデータ」とは、当社が推薦等の内容を解析して算出した候補者等のリファレンスチェックに関するグラフ等のデータを意味します。</li>
                  <li>「知的財産権」とは、著作権、特許権、実用新案権、商標権、意匠権その他の知的財産権（それらの権利を取得し、又はそれらの権利につき登録等を出願する権利を含みます。）を意味します。</li>
                  <li>「当社ウェブサイト」とは、そのドメインが「follorec.jp」である当社が運営するウェブサイト（理由の如何を問わず当社のウェブサイトのドメイン又は内容が変更された場合は、当該変更後のウェブサイトを含みます。）を意味します。</li>
                  <li>「登録希望者」とは、第3条において定義された「登録希望者」を意味します。</li>
                  <li>「登録情報」とは、第3条において定義された「登録情報」を意味します。</li>
                  <li>「登録ユーザー」とは、第3条に基づき本サービスの利用者としての登録がなされた個人又は法人を意味します。</li>
                  <li>「本サービス」とは、当社が提供する、フォロリクという名称の、求人企業が候補者等のリファレンスチェック及びバックグラウンドチェックを行うことができるプラットフォームサービス（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）を意味します。</li>
                  <li>「リファレンスチェック」とは、求人企業が候補者等の採用を検討する目的で、候補者等のスキル、勤務状況、パーソナリティその他候補者等に関して求人企業が指定する質問事項を設定し、回答者から回答を得る調査の総称を意味します。</li>
                  <li>「バックグラウンドチェック」とは、求人企業が候補者等の採用を検討する目的で、当社と提携事業者が連携して実施する、採用候補者等の学歴調査（反社チェック、SNS調査、犯罪歴等）、職歴調査（在籍期間、部署役職、退職理由等）及びデータ調査（職歴・犯罪歴・破産履歴等）等の詳細調査の総称を意味します。</li>
                  <li>「利用契約」とは、第3条第4項に定義される「利用契約」を意味します。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第3条 登録</h2>
                <ol>
                  <li>本サービスの利用を希望する者（以下「登録希望者」といいます。）は、本規約を遵守することに同意し、かつ当社の定める一定の情報（以下「登録情報」といいます。）を当社の定める方法で当社に提供することにより、当社に対し、本サービスの利用の登録を申請することができます。</li>
                  <li>登録の申請は必ず本サービスを利用する個人又は法人自身が行わなければならず、原則として代理人による登録申請は認められません。また、登録希望者は、登録の申請にあたり、真実、正確かつ最新の情報を当社に提供しなければなりません。</li>
                  <li>当社は、第1項に基づき登録を申請した者が、以下の各号のいずれかの事由に該当する場合は、登録を拒否することがあります
                    <ol>
                      <li>本規約に違反するおそれがあると当社が判断した場合当社に提供された登録情報の全部又は一部につき虚偽、誤記又は記載漏れがあった場合</li>
                      <li>過去に本サービスの利用の登録を取り消された者である場合</li>
                      <li>未成年者、成年被後見人、被保佐人又は被補助人のいずれかであり、法定代理人、後見人､保佐人又は補助人の同意等を得ていなかった場合</li>
                      <li>反社会的勢力等（暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋、社会運動等標ぼうゴロ、特殊知能暴力集団その他暴力、威力又は詐欺的手法を使用して経済的利益を追求する集団又は個人を意味します。以下同じ。）である、又は資金提供その他を通じて反社会的勢力等の維持、運営若しくは経営に協力若しくは関与する等反社会的勢力等との何らかの交流若しくは関与を行っていると当社が判断した場合</li>
                      <li>その他、当社が登録を適当でないと判断した場合</li>
                    </ol>
                  </li>
                  <li>当社は、前項その他当社の基準に従って、登録希望者の登録の可否を判断し、当社が登録を認める場合にはその旨を登録希望者に通知します。かかる通知により登録希望者の登録ユーザーとしての登録は完了し、本規約の諸規定に従った本サービスの利用にかかる契約（以下「利用契約」といいます。）が登録ユーザーと当社の間に成立します。</li>
                  <li>登録ユーザーは、登録情報に変更があった場合は、遅滞なく、当社の定める方法により、当該変更事項を当社に通知し、当社から要求された資料を提出するものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第4条 本サービスの利用</h2>
                <ol>
                  <li>本サービスの利用を希望する個人又は法人は、前条の規定に従い、登録手続を行う必要がありますが、当該登録手続によって直ちに料金が発生するものではありません。</li>
                  <li>登録ユーザーは、利用契約の有効期間中、本規約に従って、当社の定める方法に従い、本サービスを利用することができます。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第5条 リファレンスチェックの利用</h2>
                <ol>
                  <li>本サービスでは、リファレンスチェックの対象となる候補者等に関する質問事項を求人企業が確認し、求人企業が選択した当該候補者等に関する質問事項を回答者が回答の上、当該回答内容を求人企業が確認することによって候補者等のリファレンスチェックを行うことができます。</li>
                  <li>求人企業は、自己が設定した質問事項及び回答内容の全部又は一部を、当該質問事項を使用した候補者に公開することができるものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第6条 バックグラウンドチェックの利用</h2>
                <ol>
                  <li>求人企業は、候補者等に対してバックグラウンドチェックを実施することを希望する場合、学歴調査、職歴調査及びデータ調査等の詳細調査の全部又は一部を選択することにより、候補者等のバックグラウンドチェックを行うことができます。</li>
                  <li>バックグラウンドチェックを行う場合、当社は、候補者等からバックグラウンドチェックに関する同意書等（電磁的記録を含む何らかの客観的証票等を含む）を取得するものとします。</li>
                  <li>当社は、前項に定める同意書等の取得後、調査会社に対し、候補者等の履歴書、職務経歴書、同意書等及び調査会社がバックグラウンドチェックを実施するために必要な情報を送付するものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第7条 アカウント情報の管理</h2>
                <ol>
                  <li>登録ユーザーは、自己の責任において、本サービスにかかるユーザーID及びパスワード（以下「アカウント情報」といいます。）を管理及び保管するものとし、これを第三者に利用させたり、貸与、譲渡、名義変更、売買等をしてはならないものとします。</li>
                  <li>アカウント情報の管理不十分、使用上の過誤、第三者の使用等による損害の責任は登録ユーザーが負うものとし、当社は一切の責任を負いません。</li>
                  <li>登録ユーザーは、アカウント情報が盗まれ、又は第三者に使用されていることが判明した場合には、直ちにその旨を当社に通知するとともに、当社からの指示に従うものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第8条 求人企業に関する事項</h2>
                <ol>
                  <li>求人企業は、本サービス利用の対価として当社が別途定める利用料金を、振込送金、その他当社が指定する方法で当社に支払うものとします。なお、振込手数料その他支払に必要な費用は求人企業の負担とします。利用料金は本サービス画面に表示される内容、もしくは当社から求人企業へ送付された資料等に準ずるものとします。</li>
                  <li>求人企業が利用料金の支払を遅滞した場合、求人企業は年14.6％の割合による遅延損害金を当社に支払うものとします。</li>
                  <li>リファレンスチェック又はバックグラウンドチェックの実施結果によって求人企業に損害が生じた場合であっても、求人企業は当社に対して当該損害の賠償その他一切の請求を行わないものとします。</li>
                  <li>求人企業は、以下の各号のいずれかに該当する行為をしてはなりません。
                    <ol>
                      <li>本サービスを通じてリファレンスチェック又はバックグラウンドチェックを行った候補者等の採用の検討を合理的な理由なく中止する行為その他候補者等又は回答者の不合理な取扱いを行う行為</li>
                      <li>候補者等、回答者その他の第三者の要配慮個人情報（個人情報の保護に関する法律第2条第3項に定義されるものを意味します。）を本サービスを通じて取得する行為</li>
                      <li>本サービスを通じて取得した候補者等の推薦等、スコアリングデータ及び個人情報（個人情報の保護に関する法律第2条第1項に定義されるものを意味します。以下同じ。）その他の情報を、本人の同意を得ないで、候補者等のリファレンスチェック又はバックグラウンドチェックの目的以外で使用する行為及び第三者に提供する行為</li>
                    </ol>
                  </li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第9条 候補者等に関する事項</h2>
                <ol>
                  <li>候補者等は、本サービス上において、当該候補者等について本サービスを利用した求人企業が、以下の各号に定める事項について閲覧することを予め同意するものとします。なお、候補者等の推薦等については、求人企業を介することなく、回答者が自発的に回答することがあります。
                    <ol>
                      <li>候補者等の推薦等及びスコアリングデータ</li>
                      <li>候補者等の個人情報</li>
                    </ol>
                  </li>
                  <li>候補者等は、求人企業（候補者等が直接連絡をとったことがある企業に限られないものとします。）に対し、前項各号に定める事項のうち、候補者等の推薦等及び候補者等の個人情報を本サービス上で共有できるものとします。但し、求人企業と当社との間で別段の合意がある場合にはこの限りではありません。</li>
                  <li>候補者等は、回答者が回答した候補者等の推薦等の内容が候補者等の意に沿わない内容になる可能性があること、及び当該推薦等の内容が求人企業による候補者等の選考において不利になる可能性があることを予め同意するものとします。</li>
                  <li>第1項各号に定める事項が公開されたことによって候補者等に損害が生じた場合であっても、候補者等は当社に対して当該損害の賠償その他一切の請求を行わないものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第10条 回答者に関する事項</h2>
                <ol>
                  <li>回答者は、本サービスを利用する求人企業が以下の各号に定める事項を閲覧することを予め同意するものとします。
                    <ol>
                      <li>回答者の氏名及びプロフィール</li>
                      <li>回答者が回答した推薦等</li>
                    </ol>
                  </li>
                  <li>回答者は、候補者等が、求人企業（候補者等が直接連絡をとったことがある企業に限られないものとします。）に対し、前項各号に定める各事項を本サービス上で共有できることを予め同意するものとします。但し、求人企業と当社との間で別段の合意がある場合にはこの限りではありません。</li>
                  <li>回答者は前項各号に定める事項を編集又は削除することができるものとします。</li>
                  <li>回答者は本サービス上で候補者に対して記載した推薦内容に関して、推薦記載後に求人企業から連絡が来る可能性があることを予め同意するものとします。</li>
                  <li>回答者はリファレンスチェックの過程で本人確認作業があることを予め同意するものとします。また、本人確認作業の過程で提出された本人各書類等のデータに関して、当社は回答者の本人確認以外の用途に一切利用しません。</li>
                  <li>第1項各号に定める事項が公開されたことによって回答者に損害が生じた場合であっても、回答者は当社に対して当該損害の賠償その他一切の請求を行わないものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第11条 禁止行為</h2>
                <ol>
                  <li>登録ユーザーは、本サービスの利用にあたり、以下の各号のいずれかに該当する行為をしてはなりません。
                    <ol>
                      <li>当社、又は他の登録ユーザー、外部SNS事業者その他の第三者の知的財産権、肖像権、プライバシーの権利、名誉、その他の権利又は利益を侵害する行為（かかる侵害を直接又は間接に惹起する行為を含みます。）</li>
                      <li>犯罪行為に関連する行為又は公序良俗に反する行為</li>
                      <li>猥褻な情報又は青少年に有害な情報を送信する行為</li>
                      <li>異性交際に関する情報を送信する行為</li>
                      <li>法令又は当社若しくは登録ユーザーが所属する業界団体の内部規則に違反する行為</li>
                      <li>コンピューター・ウィルスその他の有害なコンピューター・プログラムを含む情報を送信する行為</li>
                      <li>当社が定める一定のデータ容量以上のデータを本サービスを通じて送信する行為</li>
                      <li>当社による本サービスの運営を妨害するおそれのある行為</li>
                      <li>本サービスを通じて取得した一切の情報を、本サービスの利用以外の目的で利用する行為（本サービスと競合するサービスを行うことを含みます。）</li>
                      <li>クローリング、ウェブスクレイピングその他これらに類する手段を用いて、当社ウェブサイト又は本サービスで提供される情報、他の登録ユーザーその他の第三者の情報を取得する行為</li>
                      <li>その他、当社が不適切と判断する行為</li>
                    </ol>
                  </li>
                  <li>当社は、本サービスにおける登録ユーザーによる情報の送信行為が前項各号のいずれかに該当し、又は該当するおそれがあると当社が判断した場合には、登録ユーザーに事前に通知することなく、当該情報の全部又は一部について削除、送信停止その他の措置をとることができるものとします。当社は、本項に基づき当社が行った措置に基づき登録ユーザーに生じた損害について一切の責任を負いません。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第12条 本サービスの委託</h2>
                <ol>
                  <li>当社は、本サービスに関する業務の一部又は全部を当社の責任において提携事業者に再委託することができるものとします。この場合、当社は再委託先に対し、本規約の当社の義務と同等の義務を負わせるものとします。</li>
                  <li>候補者等は、求人企業より当社に提供された候補者等の情報及び候補者等がバックグラウンドチェックの実施にあたり提供した同意書が、当社の提携事業者へ提供される場合があることを予め同意するものとします。</li>
                  <li>提携事業者へ提供された候補者等の情報は求人企業のリファレンスチェック又はバックグラウンドチェックの目的以外で使用されず、必要最低限の情報だけを提供するものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第13条 本サービスの停止等</h2>
                <ol>
                  <li>当社は、以下のいずれかに該当する場合には、登録ユーザーに事前に通知することなく、本サービスの利用の全部又は一部を停止又は中断することができるものとします。
                    <ol>
                      <li>本サービスに係るコンピューター・システムの点検又は保守作業を定期的又は緊急に行う場合</li>
                      <li>コンピューター、通信回線等が事故により停止した場合</li>
                      <li>火災、停電、天災地変などの不可抗力により本サービスの運営ができなくなった場合</li>
                      <li>外部SNSサービスに、トラブル、サービス提供の中断又は停止、本サービスとの連携の停止、仕様変更等が生じた場合</li>
                      <li>その他、当社が停止又は中断を必要と判断した場合</li>
                    </ol>
                  </li>
                  <li>当社は、当社の都合により、本サービスの提供を終了することができます。この場合、当社は登録ユーザーに事前に通知するものとします。</li>
                  <li>当社は、本条に基づき当社が行った措置に基づき登録ユーザーに生じた損害について一切の責任を負いません。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第14条 設備の負担等</h2>
                <ol>
                  <li>本サービスの提供を受けるために必要な、コンピューター、スマートフォン、ソフトウェアその他の機器、通信回線その他の通信環境等の準備及び維持は、登録ユーザーの費用と責任において行うものとします。</li>
                  <li>登録ユーザーは自己の本サービスの利用環境に応じて、コンピューター・ウィルスの感染の防止、不正アクセス及び情報漏洩の防止等のセキュリティ対策を自らの費用と責任において講じるものとします。</li>
                  <li>当社は、登録ユーザーが送受信したメッセージその他の情報を運営上一定期間保存していた場合であっても、かかる情報を保存する義務を負うものではなく、当社はいつでもこれらの情報を削除できるものとします。なお、当社はかかる情報の削除に基づき登録ユーザーに生じた損害について一切の責任を負いません。</li>
                  <li>登録ユーザーは、本サービスの利用開始に際し又は本サービスの利用中に、当社ウェブサイトからのダウンロードその他の方法によりソフトウェア等を登録ユーザーのコンピューター、スマートフォン等にインストールする場合には、登録ユーザーが保有する情報の消滅若しくは改変又は機器の故障、損傷等が生じないよう十分な注意を払うものとし、当社は登録ユーザーに発生したかかる損害について一切責任を負わないものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第15条 権利帰属</h2>
                <ol>
                  <li>当社ウェブサイト及び本サービスに関する所有権及び知的財産権は全て当社又は当社にライセンスを許諾している者に帰属しており、本規約に定める登録に基づく本サービスの利用許諾は、本規約において明示されているものを除き、当社ウェブサイト又は本サービスに関する当社又は当社にライセンスを許諾している者の知的財産権の譲渡又は使用許諾を意味するものではありません。登録ユーザーは、いかなる理由によっても当社又は当社にライセンスを許諾している者の知的財産権を侵害するおそれのある行為（逆アセンブル、逆コンパイル、リバースエンジニアリングを含みますが、これに限定されません。）をしないものとします。</li>
                  <li>当社ウェブサイト又は本サービスにおいて、登録ユーザーが投稿その他送信を行った文章、画像、動画その他のデータについては、当社において、無償で自由に利用（複製、複写、改変、第三者への再許諾その他のあらゆる利用を含みます。）することができるものとします。</li>
                  <li>当社は、候補者等の推薦等及びスコアリングデータ等を本サービスの向上及び統計情報として利用する目的で利用することができるものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第16条 登録取消等</h2>
                <ol>
                  <li>当社は、登録ユーザーが、以下の各号のいずれかの事由に該当する場合は、事前に通知又は催告することなく、当該登録ユーザーについて本サービスの利用を一時的に停止し、又は登録ユーザーとしての登録を取り消すことができます。
                    <ol>
                      <li>本規約のいずれかの条項に違反した場合</li>
                      <li>登録情報に虚偽の事実があることが判明した場合</li>
                      <li>当社、他の登録ユーザー、外部SNS事業者その他の第三者に損害を生じさせるおそれのある目的又は方法で本サービスを利用した、又は利用しようとした場合</li>
                      <li>外部SNS利用規約に違反したことその他の理由によって、登録ユーザーが外部SNS事業者から、そのサービスの提供や連携を受けられなくなった場合</li>
                      <li>手段の如何を問わず、本サービスの運営を妨害した場合</li>
                      <li>支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申立てがあった場合</li>
                      <li>自ら振出し、若しくは引受けた手形若しくは小切手につき、不渡りの処分を受けた場合、又は手形交換所の取引停止処分その他これに類する措置を受けたとき</li>
                      <li>差押、仮差押、仮処分、強制執行又は競売の申立てがあった場合</li>
                      <li>租税公課の滞納処分を受けた場合</li>
                      <li>死亡した場合又は後見開始、保佐開始若しくは補助開始の審判を受けた場合</li>
                      <li>6ヶ月以上本サービスの利用がなく、当社からの連絡に対して応答がない場合</li>
                      <li>第3条第3項各号に該当する場合</li>
                      <li>その他、当社が登録ユーザーとしての登録の継続を適当でないと判断した場合</li>
                    </ol>
                  </li>
                  <li>前項各号のいずれかの事由に該当した場合、登録ユーザーは、当社に対して負っている債務の一切について当然に期限の利益を失い、直ちに当社に対して全ての債務の支払を行わなければなりません。</li>
                  <li>当社及び登録ユーザーは、それぞれ30日前までに当社所定の方法で相手方に通知することにより、登録ユーザーの登録を取り消すことができます。</li>
                  <li>当社は、本条に基づき当社が行った行為により登録ユーザーに生じた損害について一切の責任を負いません。</li>
                  <li>本条に基づき登録ユーザーの登録が取り消された場合、登録ユーザーは、当社の指示に基づき、当社から提供を受けた本サービスに関連するソフトウェア、マニュアルその他の物につき、返還、廃棄その他の処分を行うものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第17条 保証の否認及び免責</h2>
                <ol>
                  <li>本サービスは、求人企業が候補者等のリファレンスチェック及びバックグラウンドチェックを行うことができるプラットフォームサービスの提供を行うものであり、候補者等及び求人企業間で締結される雇用契約その他の契約の成立の保証を行うものではありません。</li>
                  <li>本サービスは、回答者が任意に候補者等の推薦等を作成するものであり、当社は、全ての回答者が候補者等の推薦等を作成することを保証致しません。また、オプションを含むリファレンスチェック又はバックグラウンドチェックの内容に起因したクレーム又は紛争について、当社は一切責任を負わないものとします。</li>
                  <li>当社は、推薦等及びスコアリングデータその他本サービス上で提供される情報の内容につき如何なる保証も行うものではありません。本サービスは現状有姿で提供されるものであり、当社は本サービスについて、特定の目的への適合性、商業的有用性、完全性、継続性等を含め、一切保証を致しません。</li>
                  <li>当社は、推薦等及びスコアリングデータに起因して生じた損害について一切の責任を負わないものとします。</li>
                  <li>登録ユーザーが当社から直接又は間接に、本サービス、当社ウェブサイト、本サービスの他の登録ユーザーその他の事項に関する何らかの情報を得た場合であっても、当社は登録ユーザーに対し本規約において規定されている内容を超えて如何なる保証も行うものではありません。</li>
                  <li>本サービスは、外部SNSサービスと連携することがありますが、かかる連携を保証するものではなく、本サービスにおいて外部SNSサービスと連携できなかった場合でも、当社は一切の責任を負いません。</li>
                  <li>本サービスが外部SNSサービスと連携している場合において、登録ユーザーは外部SNS利用規約を自己の費用と責任で遵守するものとし、登録ユーザーと当該外部SNSサービスを運営する外部SNS事業者との間で紛争等が生じた場合でも、当社は当該紛争等について一切の責任を負いません。</li>
                  <li>登録ユーザーは、本サービスを利用することが、登録ユーザーに適用のある法令、業界団体の内部規則等に違反するか否かを自己の責任と費用に基づいて調査するものとし、当社は、登録ユーザーによる本サービスの利用が、登録ユーザーに適用のある法令、業界団体の内部規則等に適合することを何ら保証するものではありません。</li>
                  <li>本サービス又は当社ウェブサイトに関連して登録ユーザーと他の登録ユーザー、外部SNS事業者その他の第三者との間において生じた取引、連絡、紛争等については、登録ユーザーの責任において処理及び解決するものとし、当社はかかる事項について一切責任を負いません。</li>
                  <li>当社は、当社による本サービスの提供の中断、停止、終了、利用不能又は変更、登録ユーザーのメッセージ又は情報の削除又は消失､登録ユーザーの登録の取消、本サービスの利用によるデータの消失又は機器の故障若しくは損傷、その他本サービスに関連して登録ユーザーが被った損害につき、賠償する責任を一切負わないものとします。</li>
                  <li>当社ウェブサイトから他のウェブサイトへのリンク又は他のウェブサイトから当社ウェブサイトへのリンクが提供されている場合でも、当社は、当社ウェブサイト以外のウェブサイト及びそこから得られる情報に関して如何なる理由に基づいても一切の責任を負わないものとします。</li>
                  <li>当社は、本サービスに関連して登録ユーザーが被った損害について、当社の故意又は重過失を除き一切賠償の責任を負いません。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第18条 ユーザーの賠償等の責任</h2>
                <ol>
                  <li>登録ユーザーは、本規約に違反することにより、又は本サービスの利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償しなければなりません。</li>
                  <li>登録ユーザーが、本サービスに関連して他の登録ユーザー、外部SNS事業者その他の第三者からクレームを受け又はそれらの者との間で紛争を生じた場合には、直ちにその内容を当社に通知するとともに、登録ユーザーの費用と責任において当該クレーム又は紛争を処理し、当社からの要請に基づき、その経過及び結果を当社に報告するものとします。当社は当該クレーム又は紛争から生じた損害について一切の責任を負わないものとします。</li>
                  <li>登録ユーザーによる本サービスの利用に関連して、当社が、他の登録ユーザー、外部SNS事業者その他の第三者から権利侵害その他の理由により何らかの請求を受けた場合は、登録ユーザーは当該請求に基づき当社が当該第三者に支払を余儀なくされた金額を賠償しなければなりません。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第19条 秘密保持</h2>
                <ol>
                  <li>本規約において「秘密情報」とは、利用契約又は本サービスに関連して、登録ユーザーが、当社より書面、口頭若しくは記録媒体等により提供若しくは開示されたか、又は知り得た、当社の技術、営業、業務、財務、組織、その他の事項に関する全ての情報を意味します。但し、（1）当社から提供若しくは開示がなされたとき又は知得したときに、既に一般に公知となっていた、又は既に知得していたもの、（2）当社から提供若しくは開示又は知得した後、自己の責めに帰せざる事由により刊行物その他により公知となったもの、（3）提供又は開示の権限のある第三者から秘密保持義務を負わされることなく適法に取得したもの、（4）秘密情報によることなく単独で開発したもの、（5）当社から秘密保持の必要なき旨書面で確認されたもの、（6）本利用規約上で公開が予定されているものについては、秘密情報から除外するものとします。</li>
                  <li>登録ユーザーは、秘密情報を本サービスの利用の目的のみに利用するとともに、当社の書面による承諾なしに第三者に当社の秘密情報を提供、開示又は漏洩しないものとします。</li>
                  <li>第2項の定めに拘わらず、登録ユーザーは、法律、裁判所又は政府機関の命令、要求又は要請に基づき、秘密情報を開示することができます。但し、当該命令、要求又は要請があった場合、速やかにその旨を当社に通知しなければなりません。</li>
                  <li>登録ユーザーは、秘密情報を記載した文書又は磁気記録媒体等を複製する場合には、事前に当社の書面による承諾を得ることとし、複製物の管理については第2項に準じて厳重に行うものとします。</li>
                  <li>登録ユーザーは、当社から求められた場合にはいつでも、遅滞なく、当社の指示に従い、秘密情報並びに秘密情報を記載又は包含した書面その他の記録媒体物及びその全ての複製物を返却又は廃棄しなければなりません。</li>
                  <li>当社は、当社のマーケティング等の目的で、登録ユーザーの商号・商標・ロゴマークをウェブサイト及び営業資料上で使用することができるものとします。但し、登録ユーザーが事前に異議を述べた場合は、この限りではありません。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第20条 反社会的勢力の排除</h2>
                <ol>
                  <li>登録ユーザー及び当社は、自己及びその役員(取締役、監査役、執行役又はこれらに準ずる者をいい、以下「役員」といいます)その他自己を実質的に支配する者が、本利用契約締結時点において、暴力団、暴力団員、暴力団準構成員、暴力団員・暴力団準構成員でなくなった日から５年を経過しない者、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ、特殊知能暴力団等、その他これらに準ずる者（以下総称して「反社会的勢力」といいます）に該当しないこと、及び次の各号のいずれにも該当しないこと、また過去においてもそれらに該当しなかったことを表明・保証し、且つ、本利用契約締結日以降、本利用契約の履行完了までの間、自己及びその役員その他自己を実質的に支配する者が反社会的勢力に該当しないこと、及び次の各号のいずれにも該当しないことを誓約します。
                    <ul>
                      <li>反社会的勢力が経営を支配し、又は経営に実質的に関与していると認められる関係を有すること</li>
                      <li>自己、自社もしくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること</li>
                      <li>反社会的勢力に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること</li>
                      <li>反社会的勢力と社会的に非難されるべき関係を有すること</li>
                    </ul>
                  </li>
                  <li>登録ユーザー及び当社は、自ら又は第三者を利用して、暴力的要求行為、不当要求行為、脅迫的言動、暴力行為、風説流布・偽計による信用毀損行為、業務妨害行為、その他これらに準ずる行為を行わないことを誓約します。</li>
                  <li>登録ユーザー又は当社が前二項の表明・保証又は誓約に違反した場合、それが判明した時期の如何を問わず、相手方は何らの催告を要せず直ちに本利用契約を解除することができるほか、これにより被った損害の賠償を請求することができるものとします。なお、当該解除によって違反当事者に損害又は負担が生じても、当該違反当事者は相手方に対してその賠償を求めることができないものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第21条 有効期間</h2>
                <p>利用契約は、登録ユーザーについて第3条に基づく登録が完了した日に効力を生じ、当該登録ユーザーの登録が取り消された日又は本サービスの提供が終了した日のいずれか早い日まで、当社と登録ユーザーとの間で有効に存続するものとします。</p>
              </section>

              <section className="legal-section">
                <h2>第22条 本規約等の変更</h2>
                <ol>
                  <li>当社は、本サービスの内容を自由に変更できるものとします。</li>
                  <li>当社は、本規約（当社ウェブサイトに掲載する本サービスに関するルール、諸規定等を含みます。以下本項において同じ。）を変更できるものとします。本契約を変更する場合、当社は、変更後の本規約の施行時期及び内容を当社ウェブサイト上での掲示その他の適切な方法により周知し、又は登録ユーザーに当該変更内容を通知します。但し、法令上登録ユーザーの同意が必要となるような内容の変更の場合は、当社所定の方法で登録ユーザーの同意を得るものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第23条 連絡/通知</h2>
                <p>本サービスに関する問い合わせその他登録ユーザーから当社に対する連絡又は通知、及び本規約の変更に関する通知その他当社から登録ユーザーに対する連絡又は通知は、当社の定める方法で行うものとします。</p>
              </section>

              <section className="legal-section">
                <h2>第24条 本規約の譲渡等</h2>
                <ol>
                  <li>登録ユーザーは、当社の書面による事前の承諾なく、利用契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
                  <li>当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い利用契約上の地位、本規約に基づく権利及び義務並びに登録ユーザーの登録情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、登録ユーザーは、かかる譲渡につき本項において予め同意したものとします。</li>
                </ol>
              </section>

              <section className="legal-section">
                <h2>第25条 完全合意</h2>
                <p>本規約は、本規約に含まれる事項に関する当社と登録ユーザーとの完全な合意を構成し、口頭又は書面を問わず、本規約に含まれる事項に関する当社と登録ユーザーとの事前の合意（機密保持契約を含むものとします。）、表明及び了解に優先します。</p>
              </section>

              <section className="legal-section">
                <h2>第26条 分離可能性</h2>
                <p>本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有し、当社及び登録ユーザーは、当該無効若しくは執行不能の条項又は部分を適法とし、執行力を持たせるために必要な範囲で修正し、当該無効若しくは執行不能な条項又は部分の趣旨並びに法律的及び経済的に同等の効果を確保できるように努めるものとします。</p>
              </section>

              <section className="legal-section">
                <h2>第27条 存続規定</h2>
                <p>第7条（アカウント情報の管理）第2項、第8条（求人企業に関する事項）、第9条（候補者等に関する事項）第4項、第10条（回答者に関する事項）第3項、第11条（禁止行為）第2項、第13条（本サービスの停止等）第3項、第14条（設備の負担等）、第15条（権利帰属）、第16条（登録取消等）第2項、第4項及び第5項、第17条（保証の否認及び免責）から第19条（秘密保持）まで、第20条（反社会的勢力の排除）並びに第24条（本規約の譲渡等）から第29条（協議解決）までの規定は利用契約の終了後も有効に存続するものとします。但し、第19条（秘密保持）については、利用契約終了後5年間に限り存続するものとします。</p>
              </section>

              <section className="legal-section">
                <h2>第28条 準拠法及び管轄裁判所</h2>
                <p>本規約の準拠法は日本法とし、本規約に起因し又は関連する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</p>
              </section>

              <section className="legal-section">
                <h2>第29条 協議解決</h2>
                <p>当社及び登録ユーザーは、本規約に定めのない事項又は本規約の解釈に疑義が生じた場合には、互いに信義誠実の原則に従って協議の上速やかに解決を図るものとします。</p>
                <p>株式会社エグゼクティブサーチファームのプライバシーポリシーは<a href="/privacy-policy">こちら</a>からご参照ください。</p>
              </section>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TermsOfService;
